// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bce18217","455":"ca7c50e2"}[chunkId] + ".chunk.js";
};